import {IBattle} from "../../types";
import Dialog from "../../../1. Core/Controls/Dialog/Dialog";
import NP from "../../../1. Core/NP";
import {ServerAPI} from "../../../1. Core/ServerAPI";


export default class ImportBattleDataDialog extends Dialog {


	private _Battle: IBattle;
	private _logTextArea: HTMLTextAreaElement;


	_initFields(settings: object)
	{
		this._Battle = null;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = 'Import';
		this._CloseOnFrameMouseDown = false;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._ShowButtons = true;
		this._AutoDestroy = true;
		this._Width = 600;
	}

	_render()
	{
		super._render();

		this.addClass('nopad')

		this._logTextArea = NP.createNode(this._contentNode, '', 'textarea');
		this._logTextArea.style.width = '95%'
		this._logTextArea.style.height = '95%';
	}


	async _onOkButtonClick()
	{
		await ServerAPI.post(`/mma/importBattleData/${this._Battle.Id}`, JSON.parse(this._logTextArea.value));
		super._onOkButtonClick();
	}
}